/* eslint-disable no-console */
/* eslint-disable indent */
// import OtherFeatures from "./component/OtherFeatures";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import styles from "./ReleaseNote.module.css";
import PageLoader from "../../components/PageLoader";
import thumbnail from "../../assets/images/thumb.png";
import BackButton from "../../components/Button/BackButton";
const UpdateInfomation = () => {
  const { id } = useParams();
  const [releaseNote, setReleaseNote] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const fetchReleaseNote = async () => {
    try {
      const response = await fetch(
        `https://releasenote.com.ng/blog/?rest_route=/wp/v2/posts/${id}&_embed`
      );
      if (!response.ok) {
        throw new Error("Failed to fetch release note");
      }
      const data = await response.json();
      setReleaseNote(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchReleaseNote();
  }, [id]);

  if (loading) return <PageLoader />;
  if (error) return <p className={styles.error}>{error}</p>;

  // const decodeHTMLEntities = (text) => {
  //   const parser = new DOMParser();
  //   const doc = parser.parseFromString(text, "text/html");

  //   return doc.documentElement.textContent || "";
  // };

  const extractHeadings = (html) => {
    if (!html) return [];
    const doc = new DOMParser().parseFromString(html, "text/html");

    return Array.from(
      doc.querySelectorAll("h2, h3, h4, p.has-large-font-size")
    ).map((heading) => ({
      id:
        heading.id ||
        heading.textContent
          .toLowerCase()
          .replace(/\s+/g, "-")
          .replace(/[^\w-]/g, ""),
      text: heading.textContent,
      tag: heading.tagName
    }));
  };

  const addIdsToHeadings = (html) => {
    if (!html) return "<p>No Content Available</p>";
    const doc = new DOMParser().parseFromString(html, "text/html");
    doc
      .querySelectorAll("h2, h3, h4, p.has-large-font-size")
      .forEach((heading) => {
        if (!heading.id) {
          heading.id = heading.textContent
            .toLowerCase()
            .replace(/\s+/g, "-")
            .replace(/[^\w-]/g, "");
        }
      });

    return doc.body.innerHTML;
  };

  const processedContent = releaseNote
    ? addIdsToHeadings(releaseNote.content?.rendered)
    : "";
  const headings = releaseNote ? extractHeadings(processedContent) : [];

  const handleHeadingClick = (id, e) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      const yOffset = -100; // Adjust this value to control spacing
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };
  let mainCount = 1;

  const options = { year: "numeric", month: "long", day: "numeric" };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        background: "whitesmoke"
      }}
    >
      {releaseNote && (
        <div className="release_div">
          <h1 onClick={() => navigate("/product-update")} className="go_back">
            <BackButton />
            Go Back
          </h1>
          <div className={`${styles.versionheader} flex space-between`}>
            <h3> {releaseNote.title.rendered}</h3>
          </div>
          <p className={`${styles.date}`}>
            {new Date(releaseNote.date).toLocaleDateString("en-US", options)}
          </p>
          <div
            className="thumbnail"
            style={{
              backgroundImage: `url(${
                releaseNote._embedded?.["wp:featuredmedia"]?.[0]?.source_url ||
                thumbnail
              })`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center"
            }}
          >
            {/* <img
              src={
                releaseNote._embedded?.["wp:featuredmedia"]?.[0]?.source_url || thumbnail
              }
            /> */}
          </div>
          <div className={`${styles.container_div}`}>
            <div className={`${styles.itemleft}`}>
              <h3 style={{ marginBottom: 10 }}>On this page</h3>
              {headings.map((item, index) => {
                const level = parseInt(item.tag[1]) || 2;
                const isSub = level > 2;

                return (
                  <div
                    key={index}
                    style={{
                      gap: 10,
                      marginBottom: 14,
                      display: "flex",
                      alignItems: "flex-start",
                      marginLeft: isSub ? `${(level - 2) * 20}px` : "0px"
                    }}
                  >
                    {!isSub ? (
                      <span>{`${mainCount++}.`}</span>
                    ) : (
                      <span style={{ width: "0.5rem" }}>•</span>
                    )}
                    <a
                      href="#"
                      onClick={(e) => handleHeadingClick(item.id, e)}
                      style={{
                        marginBottom: 0,
                        fontWeight: isSub ? "normal" : "bold",
                        fontSize: isSub ? "0.85rem" : "0.9rem",
                        textDecoration: "none"
                      }}
                    >
                      {item.text}
                    </a>
                  </div>
                );
              })}
            </div>
            <div
              style={{
                background: "white",
                borderRadius: "8px",
                padding: "0.8rem 0"
              }}
            >
              <div className={`${styles.majorfeaturecont}`}>
                {/* <div
                  className={`${styles.majorfeatureheader} margin-inline-24`}
                >
                  <p className={`${styles.versioncontent}`}>
                    {decodeHTMLEntities(
                      releaseNote.excerpt.rendered.replace(/(<([^>]+)>)/gi, "")
                    )}
                  </p>
                </div> */}
                <h4 className={`${styles.majorfeature}`}>Product Update Details</h4>
                <div
                  className={`${styles.majorfeaturecontent} margin-inline-24`}
                >
                </div>
              </div>
              <div className="rendered">
                <div
                  className="rendered_div"
                  dangerouslySetInnerHTML={{ __html: processedContent }}
                />
              </div>
            </div>
          </div>
          {/* <OtherFeatures
            otherftsubtitle="1. Key Sub Features"
            otherftsubtitletwo="2. Additional Sub Features"
          /> */}
        </div>
      )}
    </div>
  );
};

export default UpdateInfomation;
